import "@/App.css";
import { Fragment } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PartnerProvider } from "@/context/PartnerContext";
import { ReferralProvider } from "@/context/ReferralContext";
import { PARTNERS } from "@/config/partners";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ClaimForm from "@/pages/ClaimForm";
import AffiliateLogin from "@/pages/AffiliateLogin";
import AffiliateDashboard from "@/pages/AffiliateDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PartnerProvider>
            <ReferralProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/siniestro" element={<ClaimForm />} />
                {PARTNERS.map((p) => (
                  <Fragment key={p.code}>
                    <Route path={`/${p.path}`} element={<Landing />} />
                    <Route path={`/${p.path}/siniestro`} element={<ClaimForm />} />
                  </Fragment>
                ))}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route path="/afiliado/login" element={<AffiliateLogin />} />
                <Route path="/afiliado" element={<AffiliateDashboard />} />
                <Route path="/:refSlug" element={<Landing />} />
                <Route path="/:refSlug/siniestro" element={<ClaimForm />} />
              </Routes>
            </ReferralProvider>
          </PartnerProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
